import "./header.css";

const Header = (props) => {
  return (
    <header className="header">
      <div className="header__container">
        <div className="header__container-bg">
          <p>{props.bgTitle}</p>
        </div>
        <div className="header__content">
          <p>{props.children}</p>
        </div>
      </div>
    </header>
  );
};

export default Header;
